import React, { useState, useEffect } from 'react';
import { Loading, Toast } from 'zarm';
import { connect } from 'react-redux';
import { dispatch, getState, useStore } from '@/store';
import { queryDefaultNoticeQuestionV2 } from '@/services/questionnaire';
import HolderQA from './HolderQA';
import InsuredQA from './InsuredQA';
import './index.less'; // eslint-disable-next-line import/order

import { getQueryParam } from '@/utils/tool';

const HealthNotifyForHengQin = ({
  holderList,
  insuranceList
}) => {
  const planId = useStore('PLAN_ID');
  const {
    goodsId
  } = getQueryParam() || {};
  const [isDisabledOA, setIsDisabledOA] = useState('');
  const [isDisabledOB, setIsDisabledOB] = useState('');
  const [newQuestionList, setNewQuestionList] = useState([]);
  const [questionListQB, setQuestionListQB] = useState([]); // TODO: 这里方法要改，逻辑要优化一下写法，然后isShow和isDefault两个字段要补充说明做什么用，同时要看下是否合理
  // formatQuestionList

  const recursionChangeQuestionList = questionArray => {
    questionArray.forEach(item => {
      item.questionList.forEach(changeItem => {
        var _changeItem$options;

        (changeItem === null || changeItem === void 0 ? void 0 : (_changeItem$options = changeItem.options) === null || _changeItem$options === void 0 ? void 0 : _changeItem$options.length) && changeItem.options.forEach(changeContent => {
          if ((changeContent === null || changeContent === void 0 ? void 0 : changeContent.relation) > 0) {
            item.questionList.forEach(r => {
              if (r.index === changeContent.relation) {
                r.isShow = false;
                r.isDefault = true;
              }
            });
          }
        });
      });
    });
  };

  const notifyQuestionnaireOA = isFillIn => {
    setIsDisabledOA(isFillIn);
    Loading.show();
    queryDefaultNoticeQuestionV2({
      goodsId,
      planId,
      noticeType: 'insureNotice',
      noticeObjectType: 'insured'
    }).then(res => {
      const {
        result: {
          detailList
        },
        success
      } = res;
      if (!success) return Toast.show('被保人问卷获取异常!');
      if (!(detailList !== null && detailList !== void 0 && detailList.length)) return Toast.show('问卷数据异常!');
      dispatch({
        'questionList.insuranceList': detailList === null || detailList === void 0 ? void 0 : detailList.map(item => ({
          code: item.code,
          reply: '',
          content: item.content,
          answerList: item.questionList.map(r => {
            return {
              index: r.index,
              value: '' // isRequired: true,

            };
          })
        }))
      });
      recursionChangeQuestionList(detailList);
      setQuestionListQB(detailList);
    }).catch(err => Toast.show(err || '网络阻塞，请稍等')).finally(() => {
      setIsDisabledOB(isFillIn);
      Loading.hide();
    });
  };

  const notifyQuestionnaireOB = isFillIn => setIsDisabledOB(isFillIn);

  useEffect(() => {
    if (!goodsId || !planId) return;
    queryDefaultNoticeQuestionV2({
      goodsId,
      planId,
      noticeType: 'insureNotice',
      noticeObjectType: 'holder'
    }).then(res => {
      const {
        result: {
          detailList
        },
        success
      } = res;
      if (!success) Toast.show('投保人问卷获取异常!');
      if (!(detailList !== null && detailList !== void 0 && detailList.length)) return Toast.show('问卷数据异常!');
      dispatch({
        'questionList.holderList': detailList === null || detailList === void 0 ? void 0 : detailList.map(item => ({
          code: item.code,
          reply: '',
          content: item.content,
          answerList: item.questionList.map(r => {
            return {
              index: r.index,
              value: '' // isRequired: true,

            };
          })
        }))
      });
      recursionChangeQuestionList(detailList);
      setNewQuestionList(detailList);
    }).catch(err => console.error(err || '网络阻塞，请稍等')).finally(() => setIsDisabledOA('isOAOpen'));
  }, [goodsId, planId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "HealthNotifyQuestion"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "policyHolder"
  }, isDisabledOA === 'isOAOpen' && /*#__PURE__*/React.createElement(HolderQA, {
    questionList: newQuestionList,
    holderList: holderList,
    isFillIn: notifyQuestionnaireOA
  })), /*#__PURE__*/React.createElement("div", {
    className: "theInsured"
  }, isDisabledOB === 'notifyOBOpen' && /*#__PURE__*/React.createElement(InsuredQA, {
    questionList: questionListQB,
    insuranceList: insuranceList,
    isFillIn: notifyQuestionnaireOB
  }))));
};

export default connect(state => {
  return {
    holderList: state.questionList.holderList,
    insuranceList: state.questionList.insuranceList
  };
})(HealthNotifyForHengQin);